import { render, staticRenderFns } from "./LevelOneStudents.vue?vue&type=template&id=3fdd0f27&scoped=true&"
import script from "./LevelOneStudents.vue?vue&type=script&lang=js&"
export * from "./LevelOneStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd0f27",
  null
  
)

export default component.exports